<template>
  <v-row class="mb-2">
    <v-col cols="12" :md="showJangsabot ? 6 : 12">
      <BasicButton
        class="basic-button--marketing"
        @click="moveToMarketingStore"
        header="투자 유치 가능성을 높이는"
      >
        <v-icon left color="#FFD700">mdi-star</v-icon>
        우수 마케팅 매장 인증하기
      </BasicButton>
    </v-col>
    <JangsabotBanner v-if="showJangsabot" />
  </v-row>
</template>

<script>
export default {
  name: 'MarketingStoreBanner',
  props: {
    showJangsabot: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    BasicButton: () => import('@/components/common/button/BasicButton.vue'),
    JangsabotBanner: () => import('@/components/marketing/JangsabotBanner.vue'),
  },
  methods: {
    moveToMarketingStore() {
      this.$router.push('/marketing-store')
    },
  },
}
</script>

<style lang="scss" scoped>
.basic-button--marketing {
  border: none;
  border-radius: 8px !important;
  position: relative;
  overflow: hidden;
  transition: transform 0.3s ease;
  height: 100%;
  background: linear-gradient(135deg, #4b79e4, #2b4ea2) !important;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.1) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    transition: left 0.5s ease;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(75, 121, 228, 0.3) !important;

    &::before {
      left: 100%;
    }
  }

  :deep(.message-container) {
    .header {
      color: rgba(255, 255, 255, 0.9) !important;
      font-size: 0.95rem;
      font-weight: 500;
      margin-bottom: 4px;
    }
    .body {
      font-weight: bold;
      font-size: 1.1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      color: #ffd700 !important;

      .v-icon {
        margin-right: 4px;
      }
    }
  }
}

@media (max-width: 959px) {
  .v-col {
    padding-bottom: 8px;

    &:last-child {
      padding-bottom: 0;
    }
  }
}
</style>
